import React from 'react';
import { Container, Label, Track, Radio } from './style';
import useWatchProp from 'hooks/use-watch-prop';

interface SwitchProps {
  label?: string;
  onChange?: (isSelected: boolean) => void;
  checked: boolean;
  trackColorChecked?: string;
  trackColorUnChecked?: string;
  radioColorChecked?: string;
  radioColorUnChecked?: string;
}

export default function Switch({ label, onChange, ...props }: SwitchProps) {
  const [checked, setChecked] = React.useState<boolean>(props.checked);

  useWatchProp(props.checked, setChecked);

  function onClick(): void {
    setChecked(!checked);
    onChange && onChange(!checked);
  }

  return (
    <Container {...props} checked={checked} onClick={onClick}>
      {label && <Label>{label}</Label>}
      <Track>
        <Radio />
      </Track>
    </Container>
  );
}
